import { useState, useEffect } from 'react'

import './ColorPicker.css'
import { FormControl, Popover, Box, InputAdornment, Typography, TextField } from '@mui/material'
import Compact from '@uiw/react-color-compact'
import CircleIcon from '@mui/icons-material/Circle'

export const COLOR_POPUP_MOUSETYPE = {
	COLOR_CLICK: 0,
	RGB_INPUT: 1,
}

function getBorderStyle(hex) {
	if (typeof hex !== 'string') return {}

	const normalized = hex.trim().toLowerCase()

	const isWhite = normalized === '#fff' || normalized === '#ffffff'
	return isWhite ? { border: '1px solid black', borderRadius: '50%' } : {}
}

const ColorPicker = ({ value, onClick, customStyle }) => {
	return (
		<label className="color-selector" style={{ ...customStyle?.label }} onClick={onClick}>
			<span className="circle" style={{ background: value, ...customStyle?.circle }} />
			<span>{value}</span>
		</label>
	)
}

const ColorPicker2 = ({ value, onClick, customStyle }) => {
	return (
		<FormControl fullWidth>
			<TextField
				size="small"
				value={value}
				onClick={onClick}
				InputProps={{
					readOnly: true,
					startAdornment: value && (
						<InputAdornment position="start">
							<CircleIcon
								fontSize="small"
								sx={{
									color: value,
									...getBorderStyle(value),
								}}
							/>
						</InputAdornment>
					),
				}}
			>
				<Typography variant={'h6'}>{value}</Typography>
			</TextField>
		</FormControl>
	)
}

export function PopUpColorPicker({ value, onColorChange, customStyle }) {
	const [colorPickerEl, setColorPickerEl] = useState(null)
	const [lastInteraction, setLastInteraction] = useState(COLOR_POPUP_MOUSETYPE.RGB_INPUT)

	const handleOpenColorPicker = (event) => {
		setColorPickerEl(event.currentTarget)
	}

	const handleCloseColorPicker = () => {
		setColorPickerEl(null)
	}

	const handleMouseDown = (event) => {
		const clickedElement = event.target

		// Check if the user clicked on a color swatch
		if (clickedElement.tagName === 'INPUT') {
			setLastInteraction(COLOR_POPUP_MOUSETYPE.RGB_INPUT)
		} else {
			setLastInteraction(COLOR_POPUP_MOUSETYPE.COLOR_CLICK)
		}
	}

	useEffect(() => {
		if (lastInteraction !== COLOR_POPUP_MOUSETYPE.COLOR_CLICK) return

		setLastInteraction(COLOR_POPUP_MOUSETYPE.RGB_INPUT)
		handleCloseColorPicker()
	}, [lastInteraction])

	const handleUpdateColor = (newColor) => {
		onColorChange(newColor)
	}

	const isOpenColorPicker = Boolean(colorPickerEl)
	const colorPickerId = isOpenColorPicker ? 'color-picker-popover' : undefined

	return (
		<FormControl size="small" fullWidth>
			<ColorPicker2 value={value} onClick={handleOpenColorPicker} customStyle={customStyle} />
			<Popover
				id={colorPickerId}
				open={isOpenColorPicker}
				anchorEl={colorPickerEl}
				onClose={() => handleCloseColorPicker()}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				onMouseDown={handleMouseDown}
			>
				<Compact
					color={value}
					style={{
						boxShadow: 'rgb(0 0 0 / 15%) 0px 0px 0px 1px, rgb(0 0 0 / 15%) 0px 8px 16px',
					}}
					onChange={(newColor, evn) => {
						handleUpdateColor(newColor.hex)
					}}
				/>
			</Popover>
		</FormControl>
	)
}

export default ColorPicker
